import { Home, PlayCircle, HeartPulse, TrendingUp, Mail, Download } from "lucide-react";

export type MobileTabId = "home" | "learn" | "product" | "invest" | "contact";

type TabDef = {
  id: MobileTabId | "install";
  label: string;
  title: string;
  subtitle: string;
  Icon: typeof Home;
  action?: boolean;
};

export const MOBILE_TABS: TabDef[] = [
  { id: "home", label: "Home", title: "AiMediQ™", subtitle: "Help for the team during a Code Blue.", Icon: Home },
  { id: "learn", label: "Learn", title: "Learn", subtitle: "What a Code Blue is, and how we help.", Icon: PlayCircle },
  { id: "product", label: "Product", title: "The Product", subtitle: "The smart cart and the tech inside.", Icon: HeartPulse },
  { id: "invest", label: "Invest", title: "For Investors", subtitle: "Market, model, and how to invest.", Icon: TrendingUp },
  { id: "contact", label: "Contact", title: "Contact & Legal", subtitle: "Talk to us, or read the fine print.", Icon: Mail },
  { id: "install", label: "Get app", title: "Install", subtitle: "Add AiMediQ™ to your home screen.", Icon: Download, action: true },
];

export const MobileBottomNav = ({
  active,
  onChange,
  onInstall,
}: {
  active: MobileTabId;
  onChange: (id: MobileTabId) => void;
  onInstall: () => void;
}) => (
  <nav
    aria-label="Main"
    className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
  >
    <ul className="grid grid-cols-6">
      {MOBILE_TABS.map(({ id, label, Icon, action }) => {
        const isActive = active === id;
        const isInstall = id === "install";
        return (
          <li key={id}>
            <button
              type="button"
              aria-current={isActive ? "page" : undefined}
              aria-label={isInstall ? "Install the AiMediQ app on this device" : `${label}${isActive ? " (current section)" : ""}`}
              onClick={() => (action ? onInstall() : onChange(id as MobileTabId))}
              className={`flex min-h-[60px] w-full flex-col items-center justify-center gap-1 px-1 py-2 text-[10px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
                isInstall
                  ? "text-primary bg-primary/10 rounded-lg mx-1"
                  : isActive
                    ? "text-primary"
                    : "text-muted-foreground"
              }`}
            >

              <Icon className={`h-6 w-6 ${isActive && !isInstall ? "stroke-[2.5]" : ""}`} aria-hidden="true" />
              <span>{label}</span>
            </button>
          </li>
        );
      })}
    </ul>
  </nav>
);
